<template>
  <modal-frame
    :isVisible="props.isVisible"
    :width="'400px'"
    :isOverlay="false"
    @closeDialogHandler="closeHandler(0)"
  >
    <div class="modal_title">
      <h4>{{ $t("trading.transact.al") }}</h4>
      <button class="close-btn" @click="closeHandler(0)">×</button>
    </div>
    <div class="modal_body">
      <div class="leverage-container">
        <div class="label">{{ $t("trading.transact.leverage") }}</div>
        <div class="control">
          <button @click="decrease">–</button>
          <span>{{ leverage }}x</span>
          <button @click="increase">+</button>
        </div>

        <div class="slider" @click="handleClick">
          <div
            v-for="point in points"
            :key="point"
            class="tick"
            :style="{ left: getLeftPercent(point) + '%' }"
          ></div>
          <div class="track" :style="{ width: position + '%' }"></div>
          <div
            class="marker"
            @mousedown="handleMouseDown"
            :style="{ left: position + '%' }"
          ></div>
        </div>

        <div class="scale">
          <span
            v-for="point in points"
            :key="point"
            :style="{ left: getLeftPercent(point) + '%' }"
            >{{ point }}x</span
          >
        </div>
      </div>
    </div>

    <div class="col-12 text-center modal_btn">
      <button type="button" class="btn-primary mlr-5" @click="closeHandler(1)">
        {{ $t("trading.common.confirm") }}
      </button>
    </div>
  </modal-frame>
  <ModalAlert
    :isVisible="alertDialog.isVisible"
    :content="alertDialog.content"
    @closeDialogHandler="closeAlertDialogHandler"
    :is-btn="true"
  />
</template>

<script setup>
import {
  defineProps,
  defineEmits,
  ref,
  onMounted,
  onBeforeUnmount,
  computed,
  watch,
} from "vue";
import ModalAlert from "@/components/common/modal/ModalAlert.vue";
import ModalFrame from "@/components/common/modal/ModalFrame.vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
const store = useStore();
const emit = defineEmits(["closeDialogHandler"]);
const props = defineProps({
  isVisible: Boolean,
  leverage: Number,
  width: String,
});
const { t } = useI18n();
const alertDialog = ref({
  isVisible: false,
  content: "",
});
const leverage = ref(props.leverage);
const position = ref(0);
const dragging = ref(false);
const ticker = computed(() => store.state.transact.ticker);
const isCheckLeverage = computed(() => {
  const positionList = store.state.user_history.positionList;
  const sameSymbol = positionList.find(
    (v) => v.symbol === ticker.value && v.margin_type === "isolated"
  );
  return sameSymbol;
});
// const points = [1, 2, 3, 4, 5];
// const pointLength = 5;
// const pointLengthLeft = 4;
const points = [1, 5, 10, 15, 20];
const pointLength = 20;
const pointLengthLeft = 19;

const getLeftPercent = (val) => ((val - 1) / pointLengthLeft) * 100;

const updatePosition = () => {
  // position.value = ((leverage.value - 1) / 19) * 100;
  position.value = ((leverage.value - 1) / pointLengthLeft) * 100;
};

const increase = () => {
  if (leverage.value < pointLength) {
    leverage.value++;
    updatePosition();
  }
};

const decrease = () => {
  if (leverage.value > 1) {
    leverage.value--;
    updatePosition();
  }
};

const handleClick = (e) => {
  const rect = e.currentTarget.getBoundingClientRect();
  const clickX = e.clientX - rect.left;
  const percent = (clickX / rect.width) * 100;
  const lev = Math.round((percent / 100) * pointLengthLeft) + 1;
  leverage.value = Math.min(Math.max(lev, 1), pointLength);
  updatePosition();
};

const handleMouseDown = () => {
  dragging.value = true;
};

const handleMouseMove = (e) => {
  if (!dragging.value) return;

  const slider = document.querySelector(".slider");
  const rect = slider.getBoundingClientRect();
  const moveX = e.clientX - rect.left;
  const percent = (moveX / rect.width) * 100;
  const lev = Math.round((percent / 100) * pointLengthLeft) + 1;
  leverage.value = Math.min(Math.max(lev, 1), pointLength);
  updatePosition();
};

const handleMouseUp = () => {
  dragging.value = false;
};

const closeHandler = (bool) => {
  if (bool) {
    if (
      isCheckLeverage.value &&
      leverage.value < Number(isCheckLeverage.value.leverage)
    ) {
      alertDialog.value.isVisible = true;
      alertDialog.value.content = t("trading.transact.caution05");
    } else {
      emit("closeDialogHandler", leverage.value);
    }
  } else {
    emit("closeDialogHandler");
    leverage.value = props.leverage;
    updatePosition();
  }
};
const closeAlertDialogHandler = () => {
  alertDialog.value.isVisible = false;
};
onMounted(() => {
  window.addEventListener("mousemove", handleMouseMove);
  window.addEventListener("mouseup", handleMouseUp);
});

watch(
  () => props.leverage,
  () => {
    leverage.value = props.leverage;
    updatePosition();
  }
);

onBeforeUnmount(() => {
  window.removeEventListener("mousemove", handleMouseMove);
  window.removeEventListener("mouseup", handleMouseUp);
});
</script>
<style lang="scss" scoped>
@import url("@/assets/scss/components/common/modal.scss");
.leverage-container {
  /* width: 400px; */
  color: #fff;
}
.label {
  margin-bottom: 6px;
  font-size: 14px;
  color: var(--txt-default-color);
}
.control {
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--section-color);
  border: 1px solid #999;
  padding: 6px 12px;
  border-radius: 6px;
  margin-bottom: 20px;
}
.control button {
  background: none;
  color: var(--txt-default-color);
  border: none;
  font-size: 18px;
  cursor: pointer;
  padding: 4px 12px;
}
.control span {
  flex: 1;
  text-align: center;
  font-weight: bold;
  font-size: 1.5rem;
  /* color: #2b2b2b; */
}
</style>
